export const scrollToError = {
    methods: {
        scrollToError() {
            this.$nextTick(() => {
                document.querySelector(".text-red-600").scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            });
        }
    }
};

export const scrollToRef = {
    methods: {
        scrollToRef() {
            this.$nextTick(() => {
                this.$refs.scrollToMe.scrollIntoView({
                    behavior: "smooth"
                });
            });
        }
    }
};
